import React, { Fragment, Component } from "react";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";
import ProfilePreview from "../commons/ProfilePreview";

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "white",
    color: "black",
    width: 500,
    fontSize: 15,
    fontFamily: "inherit",
    padding: 0,
    boxShadow: "0px 8px 16px 0px rgb(0 0 0 / 20%)",
  },
}));

class Username extends Component {
  state = {
    hovered: false,
  };

  setHovered(hovered) {
    this.setState({
      hovered,
    });
  }

  render() {
    const { hovered } = this.state;
    const { username, onClick, style } = this.props;
    return (
      <Fragment>
        <HtmlTooltip
          placement="bottom"
          PopperProps={{
            disablePortal: true,
          }}
          title={<ProfilePreview username={username} onClick={onClick} />}
          onClose={() => this.setHovered(false)}
          onOpen={() => this.setHovered(true)}
          open={hovered}
          disableFocusListener
          disableTouchListener
          arrow
          sx={{
            "& .MuiTooltip-arrow": {
              color: "white",
            },
          }}
        >
          <div>
            <div className="post-author" style={{...style}} onClick={onClick}>
              {username}
            </div>
          </div>
        </HtmlTooltip>
      </Fragment>
    );
  }
}

export default Username;
